import { useKey } from "react-use";
import { useRef } from "react";

export const useKeyboardShortcut = (key, fn) => {
  // useKey memoizes its handler, so it would keep the fn of the first render
  // and every state it closed over: the F toggle only ever opened. The ref
  // always hands it the latest fn.
  const fnRef = useRef(fn);
  fnRef.current = fn;

  return useKey(
    (event) => {
      if (event.ctrlKey || event.metaKey || event.altKey) return false;
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA" ||
        event.target.isContentEditable
      )
        return false;
      // Caps Lock or Shift turn "f" into "F".
      return event.key.toLowerCase() === key;
    },
    (event) => fnRef.current(event),
    undefined,
    [key]
  );
};
